module.exports = __webpack_public_path__ + "img/foreignpayIcon.25c1b79a.jpg";